import axiosInstance from "axios";
import { goBackToWebsite } from "../../../utills/common";

// public axios
export const publicAxios = axiosInstance.create({
  withCredentials: true,
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
  },
  baseURL: `${process.env.REACT_APP_NEST_BASE_URL}/public/toolkit`,
});

// default axios
const axios = axiosInstance.create({
  withCredentials: true,
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
  },
  baseURL: `${process.env.REACT_APP_NEST_BASE_URL}/toolkit`,
});
axios.CancelToken = axiosInstance.CancelToken;

// Add a request interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response && error?.response?.status === 401) return goBackToWebsite();
    return Promise.reject(error);
  }
);

export default axios;
